// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32FYP","toggle":"styles_toggle__18-4f","preview":"styles_preview__3FNyF"};